<template lang="pug">
  div(class="billing-overview")
    template(v-if="loading")
      div(class="billing-overview__content")
        v-skeleton-loader(
          v-for="loader in 2"
          type="card-heading, article, button"
        )
    template(v-else)
      div(class="billing-overview__content")
        billing-current-plan-card
        billing-documents-cards
      billing-autopayment-banner
</template>

<script>
import { mapGetters } from 'vuex'
import currencyFormat from '~/mixins/filters/currencyFormat'
import actions from '~/modules/billing/mixins/actions'
import BillingCurrentPlanCard from '~/modules/billing/components/billing-current-plan-card'
import BillingDocumentsCards from '~/modules/billing/components/billing-documents-cards'
import BillingAutopaymentBanner from '~/modules/billing/components/billing-autopayment-banner'

export default {
  name: 'BillingOverview',
  components: {
    BillingDocumentsCards,
    BillingCurrentPlanCard,
    BillingAutopaymentBanner
  },
  mixins: [currencyFormat, actions],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('billing', {
      changeTabIndex: 'changeTabIndex'
    })
  },
  watch: {
    changeTabIndex(idx) {
      this.$emit('goToTab', idx)
      this.$store.commit('billing/SET_CHANGE_TAB_INDEX', null)
    }
  },
  mounted() {
    if (this.$route.query.to === 'plans') {
      this.$emit('goToTab', 1)
    }
    if (this.$route.query.invoice) {
      this.updateToPremium(false)
    }
  }
}
</script>

<style lang="scss">
.billing-overview {
  &__content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      grid-template-columns: 1fr 1fr;
    }
  }

  &__card {
    border-radius: 16px;
    padding: 16px;

    border: 1px solid $border-disabled;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &-top {
      position: relative;
    }

    &-arrows {
      display: flex;
      align-items: center;

      position: absolute;
      top: 16px;
      right: 16px;
      z-index: map-get($zIndexes, 'base');
    }

    &-arrow {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 32px !important;
      height: 32px !important;
    }

    &.gradient-bg {
      background: url('assets/images/billing-card-bg.png') no-repeat;
      background-size: cover;
      border-width: 0;
    }
  }

  &__items {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    padding-bottom: 24px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &__item {
    border-radius: 12px;
    background: $white;
    padding: 12px;

    &.gray {
      background: #f8f8f8;
    }
  }

  &__actions {
    padding-top: 24px;
  }
}
</style>
